import type { SidebarNavItem } from './sidebar-nav.types';
import { APP_ROUTES } from '@/routes/routes.type';

export const PUBLIC_BLOG_ROUTER_LINK = `/${APP_ROUTES.BLOG}`;

export const PUBLIC_BLOG_NAV_ITEM: SidebarNavItem = {
  icon: 'newspaper',
  title: 'Блог',
  subtitle: 'Статьи и материалы',
  routerLink: PUBLIC_BLOG_ROUTER_LINK,
};

export function isPublicBlogNavItem(item: SidebarNavItem): boolean {
  return item.routerLink === PUBLIC_BLOG_ROUTER_LINK;
}

export const GUEST_MENU_ITEMS: SidebarNavItem[] = [
  { icon: 'log-in', title: 'Вход', subtitle: 'Войти в аккаунт', routerLink: '/login' },
  { icon: 'user-plus', title: 'Регистрация', subtitle: 'Создать аккаунт', routerLink: '/register' },
  PUBLIC_BLOG_NAV_ITEM,
];

export const USER_MENU_ITEMS: SidebarNavItem[] = [
  {
    icon: 'clipboard-list',
    title: 'Основной опросник',
    subtitle: 'Проходить каждые 7-14 дней',
    routerLink: '/' + APP_ROUTES.QUESTIONNAIRE_MAIN,
  },
  {
    icon: 'sun',
    title: 'Ежедневная рефлексия',
    subtitle: 'Перспектива и ретроспектива дня',
    routerLink: '/' + APP_ROUTES.DAILY_REFLECTION,
  },
  {
    icon: 'history',
    title: 'История',
    subtitle: 'Записи опросников и рефлексий',
    routerLink: '/history',
  },
  {
    icon: 'book-open',
    title: 'Справочник',
    subtitle: 'Термины и обозначения',
    routerLink: '/reference',
  },
  PUBLIC_BLOG_NAV_ITEM,
  {
    icon: 'help-circle',
    title: 'Поддержка',
    subtitle: 'Мои обращения в поддержку',
    routerLink: '/' + APP_ROUTES.SUPPORT,
  },
];

export const CONSULTANT_MENU_ITEMS: SidebarNavItem[] = [
  {
    icon: 'users',
    title: 'Мои подопечные',
    subtitle: 'Пользователи с разрешением',
    routerLink: '/consultant/clients',
  },
  {
    icon: 'user-check',
    title: 'Профили подопечных',
    subtitle: 'Просмотр профилей',
    routerLink: '/consultant/profiles',
  },
  {
    icon: 'clipboard-check',
    title: 'Результаты опросов',
    subtitle: 'Данные опросников подопечных',
    routerLink: '/consultant/results',
  },
  {
    icon: 'trending-up',
    title: 'Аналитика',
    subtitle: 'Сводка по подопечным',
    routerLink: '/consultant/analytics',
  },
  {
    icon: 'book-open',
    title: 'Справочник',
    subtitle: 'Термины и обозначения',
    routerLink: '/consultant/reference',
  },
  PUBLIC_BLOG_NAV_ITEM,
  {
    icon: 'help-circle',
    title: 'Поддержка',
    subtitle: 'Обращения в поддержку',
    routerLink: '/' + APP_ROUTES.SUPPORT,
  },
];

const MODERATOR_BASE_ITEMS: SidebarNavItem[] = [
  {
    icon: 'users',
    title: 'Пользователи',
    subtitle: 'Все пользователи системы',
    routerLink: '/users',
  },
  {
    icon: 'file-check',
    title: 'Модерация контента',
    subtitle: 'Проверка и одобрение',
    routerLink: '/moderator/content',
  },
  {
    icon: 'flag',
    title: 'Жалобы',
    subtitle: 'Обращения пользователей',
    routerLink: '/moderator/reports',
  },
  {
    icon: 'activity',
    title: 'Аудит действий',
    subtitle: 'История изменений',
    routerLink: '/moderator/audit',
  },
  {
    icon: 'scroll-text',
    title: 'Логи',
    subtitle: 'Системные логи',
    routerLink: '/moderator/logs',
  },
  {
    icon: 'help-circle',
    title: 'Обращения',
    subtitle: 'Обращения пользователей',
    routerLink: '/' + APP_ROUTES.ADMIN_SUPPORT,
  },
  PUBLIC_BLOG_NAV_ITEM,
];

const MODERATOR_ADMINISTRATION_ITEMS: SidebarNavItem[] = [
  {
    icon: 'clipboard-list',
    title: 'Опросники',
    subtitle: 'Справочник опросников',
    routerLink: '/admin/questionnaires',
    section: 'Администрирование',
  },
  {
    icon: 'boxes',
    title: 'Модели',
    subtitle: 'Справочник моделей',
    routerLink: '/admin/models',
    section: 'Администрирование',
  },
  {
    icon: 'heart-handshake',
    title: 'Практики',
    subtitle: 'Справочник интервенций',
    routerLink: '/admin/interventions',
    section: 'Администрирование',
  },
  {
    icon: 'list-ordered',
    title: 'Ответы',
    subtitle: 'Справочник вариантов ответов',
    routerLink: '/admin/answers',
    section: 'Администрирование',
  },
  {
    icon: 'git-branch',
    title: 'Процессы',
    subtitle: 'Справочник процессов',
    routerLink: '/admin/processes',
    section: 'Администрирование',
  },
  {
    icon: 'ruler',
    title: 'Шкалы',
    subtitle: 'Домены и коррекционные шкалы',
    routerLink: '/admin/scales',
    section: 'Администрирование',
  },
];

export const MODERATOR_MENU_ITEMS: SidebarNavItem[] = [
  ...MODERATOR_BASE_ITEMS,
  ...MODERATOR_ADMINISTRATION_ITEMS,
];

const ADMIN_EXTRA_ITEMS: SidebarNavItem[] = [
  {
    icon: 'clipboard-list',
    title: 'Опросники',
    subtitle: 'Справочник опросников',
    routerLink: '/admin/questionnaires',
    section: 'Администрирование',
  },
  {
    icon: 'boxes',
    title: 'Модели',
    subtitle: 'Справочник моделей',
    routerLink: '/admin/models',
    section: 'Администрирование',
  },
  {
    icon: 'heart-handshake',
    title: 'Практики',
    subtitle: 'Справочник интервенций',
    routerLink: '/admin/interventions',
    section: 'Администрирование',
  },
  {
    icon: 'list-ordered',
    title: 'Ответы',
    subtitle: 'Справочник вариантов ответов',
    routerLink: '/admin/answers',
    section: 'Администрирование',
  },
  {
    icon: 'git-branch',
    title: 'Процессы',
    subtitle: 'Справочник процессов',
    routerLink: '/admin/processes',
    section: 'Администрирование',
  },
  {
    icon: 'ruler',
    title: 'Шкалы',
    subtitle: 'Домены и коррекционные шкалы',
    routerLink: '/admin/scales',
    section: 'Администрирование',
  },
  {
    icon: 'book-open',
    title: 'Справочник',
    subtitle: 'Управление материалами справочника',
    routerLink: '/' + APP_ROUTES.ADMIN_REFERENCE,
    section: 'Администрирование',
  },
  {
    icon: 'file-text',
    title: 'Инфо-страницы',
    subtitle: 'Управление информационными страницами',
    routerLink: '/' + APP_ROUTES.ADMIN_INFO_PAGES,
    section: 'Администрирование',
  },
  {
    icon: 'layout-list',
    title: 'Блог',
    subtitle: 'Посты и категории блога',
    routerLink: '/' + APP_ROUTES.ADMIN_BLOG,
    section: 'Блог',
  },
  {
    icon: 'user-cog',
    title: 'Управление ролями',
    subtitle: 'Назначение ролей пользователям',
    routerLink: '/admin/roles',
  },
  {
    icon: 'settings',
    title: 'Системные настройки',
    subtitle: 'Конфигурация системы',
    routerLink: '/admin/settings',
  },
];

const adminExclusiveNavStartIndex = ADMIN_EXTRA_ITEMS.findIndex(
  (item) => item.title === 'Справочник' && item.section === 'Администрирование',
);

if (adminExclusiveNavStartIndex < 0) {
  throw new Error('sidebar-nav.config: «Справочник» должен быть в ADMIN_EXTRA_ITEMS');
}

/** Пункты только для админа (нет в MODERATOR_MENU_ITEMS). Показывать модератору, если в профиле есть роль admin — иначе активный «модератор» скрывает блог и др., хотя маршруты доступны через roleGuard. */
export const ADMIN_EXCLUSIVE_NAV_ITEMS: SidebarNavItem[] = ADMIN_EXTRA_ITEMS.slice(
  adminExclusiveNavStartIndex,
);

export const ADMIN_MENU_ITEMS: SidebarNavItem[] = [...MODERATOR_BASE_ITEMS, ...ADMIN_EXTRA_ITEMS];
